import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const DangerIcon: React.FC<IconProps> = ({ color = "#fd6a65" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g fill={color}>
          <path
            d="m13.507 10.542-5.45 9.413c-.912 1.576-1.368 2.364-1.3 3.01a2 2 0 0 0 .813 1.41c.525.383 1.436.383 3.257.383h10.9c1.82 0 2.731 0 3.257-.382a2 2 0 0 0 .813-1.41c.068-.647-.389-1.435-1.301-3.011l-5.45-9.413c-.909-1.57-1.363-2.356-1.957-2.62a2 2 0 0 0-1.625 0c-.593.264-1.047 1.05-1.957 2.62Z"
            fillRule="nonzero"
            opacity=".12"
          />
          <path d="M16.785 8.608a1.25 1.25 0 0 0-1.016 0c-.108.048-.274.174-.553.568-.276.39-.597.944-1.06 1.741l-5.45 9.414c-.463.8-.784 1.357-.986 1.793-.203.44-.23.646-.218.764.037.352.222.673.509.881.095.07.288.15.77.195.479.044 1.12.044 2.046.044h10.9c.925 0 1.567 0 2.046-.044.482-.045.674-.125.77-.195a1.25 1.25 0 0 0 .508-.881c.012-.118-.014-.325-.218-.764-.201-.436-.522-.992-.986-1.793l-5.45-9.413c-.462-.798-.783-1.352-1.06-1.742-.279-.394-.444-.52-.552-.568Zm-1.625-1.37a2.75 2.75 0 0 1 2.234 0c.485.215.843.613 1.167 1.07.322.454.677 1.068 1.115 1.825l.02.033 5.449 9.413.02.033c.44.76.796 1.376 1.03 1.882.236.51.403 1.02.348 1.55a2.75 2.75 0 0 1-1.118 1.939c-.43.312-.956.423-1.515.474-.556.051-1.267.051-2.145.051H10.789c-.878 0-1.59 0-2.145-.05-.56-.052-1.085-.163-1.515-.475a2.75 2.75 0 0 1-1.118-1.94c-.056-.529.112-1.04.348-1.55.234-.505.59-1.12 1.03-1.88l.02-.034 5.45-9.413.018-.033c.439-.757.794-1.37 1.115-1.824.324-.458.683-.856 1.168-1.072Zm1.117 5.77a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Zm0 8.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
        </g>
      </g>
    </svg>
  );
};
